<template>
  <!--  VISTA LISTAR-->
  <template v-if="view === 'listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
      :custom-create-actions="[listDepartamentos, listCiudades]" 
      @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
      @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" 
                    :selected-data="selectedJuzgado" 
                    :table-columns="tableColumns"
                    :collection-data="collectionData" 
                    :auth-token="authToken" 
                    :list-api="listApi" 
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-actions="[listDepartamentos, listCiudades]"
                    @updateValues="setupUpdateValues">
    </TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
      @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent  :view="view" 
                            :paginate="paginate" 
                            :selected-data="selectedJuzgado" 
                            :load-data="loadJuzgado"
                            :entity="entity" 
                            :auth-token="authToken" 
                            :list-api="listApi" 
                            :queries="queries" 
                            @updateValues="setupUpdateValues"
                            :custom-update-load-data="customUpdateLoadData">
      <component  :is="childFormComponent" 
                  :load-data="loadJuzgado" 
                  :selected-data="selectedJuzgado" 
                  :view="view" 
                  :collection-departamento="collectionDepartamento"
                  :collection-municipio="collectionMunicipio" 
                  :custom-update-value-data="customUpdateValueData"
                  @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>

import HeaderComponent from "@/layouts/main/HeaderComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import TableComponent from "@/layouts/main/TableComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import { useAuth } from "@/components/auth/store/composables";
import { reactive, ref } from "vue";
import { listCollectionData, useLayoutMain } from "@/layouts/main";
import JuzgadoCrearActualizarComponent from "./components/JuzgadoCrearActualizarComponent.vue";
export default {
  name: "JuzgadosCRUD",
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    JuzgadoCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Juzgados',
      entity: { gender: 'm', value: 'Juzgado' },
      childFormComponent: 'JuzgadoCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "ID",
        },
        'identificacion_juzgado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Identificación del Juzgado",
        },
        'nombre_juzgado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre del Juzgado",
        },
        'nombreDepto.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Departamento",
        },
        'nombreCiudad.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Municipio",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      }
    };
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionDepartamento = ref([]);
    const collectionMunicipio = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedJuzgado = ref({
      id: '',
      identificacion_juzgado:'',
      nombre_juzgado: '',
      id_departamento: '',
      id_municipio: '',
      estado: ''
    });
    const loadJuzgado = ref({
      identificacion_juzgado:'',
      nombre_juzgado: '',
      id_departamento: '',
      id_municipio: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_JUZGADO_CREATE,
      list: process.env.VUE_APP_NEST_JUZGADO_FINDALL,
      update: process.env.VUE_APP_NEST_JUZGADO_UPDATE,
      updateState: process.env.VUE_APP_NEST_JUZGADO_UPDATESTATE
    });

    const customUpdateValueData = (key, value) => {
      if (['identificacion_juzgado','nombre_juzgado','id_departamento', 'id_municipio'].includes(key)) return Number(value);
      return value;
    };

    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      
      for (const key of Object.keys(selectedJuzgado.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedJuzgado.value = selectedCollectionData;
    }

    const customUpdateLoadData = () => {
      for (const key in loadJuzgado.value) {
        let value = loadJuzgado.value[key];
        value = customUpdateValueData(key, value);
      }
    };

    const listDepartamentos = async () => await listCollectionData(
      process.env.VUE_APP_NEST_DEPARTAMENTO_FINDALL,
      { 'collectionDepartamento': collectionDepartamento },
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const listCiudades = async () => await listCollectionData(
      process.env.VUE_APP_NEST_CIUDAD_FINDALL,
      { 'collectionMunicipio': collectionMunicipio },
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);

    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedJuzgado, loadJuzgado, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedJuzgado,
      loadJuzgado,
      listApi,
      paginate,
      queries,
      collectionDepartamento,
      collectionMunicipio,
      setupUpdateValues,
      cleanLoadSelectedData,
      listDepartamentos,
      listCiudades,
      customUpdateValueData,
      customUpdateLoadData,
      customUpdateSelectedData,
      console: console,
    };
  }
};
</script>